import React from 'react';

import * as S from './styles';

export default function ReleaseNotificacao() {
  return (
    <div>
      <S.Observacao>
        Deseja visualizar todas as informações sobre a nova versão ?
      </S.Observacao>
    </div>
  );
}
